var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96.2 28.8",
    style: {
      enableBackground: "new 0 0 96.2 28.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,28.3v-28h10.9c1.8,0,3.4,0.2,4.6,0.6s2.3,1.2,3.2,2.4S20,5.9,20,7.6c0,1.5-0.5,2.9-1.4,4s-2.1,1.9-3.7,2.2 c2,0.3,3.5,1.1,4.5,2.4s1.5,2.7,1.5,4.5c0,2.2-0.7,4-2.1,5.4c-1.4,1.4-3.6,2.2-6.5,2.2H0z M4.8,12.1H11c1.3,0,2.3-0.4,3-1.1 s1.1-1.7,1.1-2.9c0-1.3-0.4-2.2-1.3-2.8S12,4.4,10.9,4.4h-6L4.8,12.1L4.8,12.1z M4.8,24.1h6.5c1.4,0,2.5-0.4,3.3-1.1 s1.2-1.7,1.2-2.9c0-1.2-0.4-2.1-1.2-2.9s-1.9-1.1-3.2-1.1H4.8V24.1z M47.5,28.3h-5.4l-2.2-6.7H29.1l-2.2,6.7h-4.3l9.3-28h6.2 L47.5,28.3z M38.5,17.6L34.4,5.1l-4.1,12.5H38.5z M65.5,18.6l4.7,0.5c-0.3,2.8-1.4,5.1-3.3,6.9s-4.2,2.8-7.3,2.8 c-2.6,0-4.6-0.6-6.2-1.9s-2.8-3-3.7-5.2c-0.9-2.2-1.3-4.6-1.3-7.3c0-4.3,1-7.7,3-10.4s4.8-4,8.3-4c2.8,0,5.1,0.9,6.9,2.6 s3,4.2,3.5,7.3l-4.7,0.5c-0.9-4.2-2.8-6.3-5.7-6.3c-1.9,0-3.4,0.9-4.4,2.6s-1.6,4.3-1.6,7.6c0,3.4,0.6,6,1.7,7.7 c1.1,1.7,2.6,2.6,4.5,2.6c1.5,0,2.7-0.6,3.8-1.7C64.8,21.8,65.4,20.2,65.5,18.6z M96.2,28.3h-5.6L84.7,14l-5.4,7.2v7.1h-5v-28h5V15 c0.6-1,1.1-1.7,1.4-2.1L90,0.3h5.1l-6.6,9.2L96.2,28.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/B.82b18941267079f4fb54b84468934894.svg";
export { ForwardRef as ReactComponent };